<template>
  <div>
    <p>
      Jeder Raum hat auch ein Ablage zum Speichern von Dateien für Benutzer die
      gerade nicht online sind.
    </p>
    <p>
      Diese Dateien werden daher nicht direkt von Gerät zu Gerät übertragen,
      sondern sicher auf unseren Servern gespeichert.
    </p>
  </div>
</template>

<script>
  import {switchRoom} from './step-utils';


  const component = {
    name: 'StepRoomFiles'
  };


  export const StepRoomFiles = {
    target: '[href="/share/files"]',
    before: async () => {
      await switchRoom('example-room');
    },
    header: 'Dateien',
    content: component
  };


  export default component;
</script>
